import React from "react";
import ButtonGroup from "../../scoreboard-content/buttons/ButtonGroup";
import { useStyles } from "../ScoreboardStyles.css";

const ScoreboardBottomButtons = ({
    points,
    penalties,
    athleteLeft,
    decisionHandlers,
    disabled,
}) => {
    const classes = useStyles();

    return (
        <div className={classes.scoreboardContainer}>
            <div className={classes.scoreboardButtonLeftGroup}>
                <ButtonGroup
                    points={points}
                    penalties={penalties}
                    position={"left"}
                    athlete={athleteLeft === "red" ? "red" : "blue"}
                    decisionHandlers={decisionHandlers}
                    disabled={disabled}
                />
            </div>
            <div className={classes.scoreboardButtonRightGroup}>
                <ButtonGroup
                    points={points}
                    penalties={penalties}
                    position={"right"}
                    athlete={athleteLeft === "red" ? "blue" : "red"}
                    decisionHandlers={decisionHandlers}
                    disabled={disabled}
                />
            </div>
        </div>
    );
};

export default ScoreboardBottomButtons;
